/**
 * Notificações já abertas neste navegador (por uuid). Serve só para a marca de
 * "nova" e para não repetir o aviso de chegada — perder isso (aba anônima, cache
 * limpo) apenas mostra o aviso de novo, por isso fica no localStorage.
 */
const CHAVE = 'jkaw.notificacao.vistas';
const LIMITE = 300;

function ler(): string[] {
  try {
    const bruto = localStorage.getItem(CHAVE);
    const lista = bruto ? JSON.parse(bruto) : [];
    return Array.isArray(lista) ? lista : [];
  } catch {
    return [];
  }
}

export function notificacaoFoiVista(uuid?: string): boolean {
  return !!uuid && ler().includes(uuid);
}

export function marcarNotificacaoVista(uuid?: string) {
  if (!uuid) {
    return;
  }
  const lista = ler().filter(u => u !== uuid);
  lista.push(uuid);
  try {
    localStorage.setItem(CHAVE, JSON.stringify(lista.slice(-LIMITE)));
  } catch {
    // sem storage: segue sem memória
  }
}
